import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { Link as RouterLink } from 'react-router-dom'
import { useSimulations } from '../api/hooks'
import { formatDate, formatEUR, formatEUR2, formatPct } from '../format'
import { useAmountsHidden } from '../privacy'
import PrivacyToggle from '../components/PrivacyToggle'

export default function SimulationsPage() {
  const { data, loading, error } = useSimulations()
  useAmountsHidden()

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ mb: 3, justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="h4">Simulations</Typography>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <PrivacyToggle />
          <Button
            component={RouterLink}
            to="/simulations/new"
            variant="contained"
            startIcon={<AddIcon />}
          >
            Nouvelle simulation
          </Button>
        </Stack>
      </Stack>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {data && data.length === 0 && (
        <Card>
          <CardContent>
            <Typography sx={{ color: 'text.secondary' }}>
              Aucune simulation. Créez votre première simulation pour estimer la rentabilité d'un
              bien.
            </Typography>
          </CardContent>
        </Card>
      )}

      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        }}
      >
        {data?.map((s) => (
          <Card key={s.id}>
            <CardActionArea
              component={RouterLink}
              to={`/simulations/${s.id}`}
              sx={{ height: '100%' }}
            >
              <CardContent>
                <Stack
                  direction="row"
                  sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
                >
                  <Typography variant="h6">{s.name}</Typography>
                  <Chip
                    size="small"
                    label={s.project ? 'Actif' : 'Brouillon'}
                    color={s.project ? 'success' : 'default'}
                  />
                </Stack>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {formatDate(s.createdAt)}
                </Typography>
                <Stack direction="row" sx={{ mt: 2, justifyContent: 'space-between' }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Cash-flow
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: s.results.monthlyCashFlow >= 0 ? 'success.main' : 'error.main' }}
                  >
                    {formatEUR2(s.results.monthlyCashFlow)}/mois
                  </Typography>
                </Stack>
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Rendement net
                  </Typography>
                  <Typography variant="body2">{formatPct(s.results.netYield)}</Typography>
                </Stack>
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Coût de l'investissement
                  </Typography>
                  <Typography variant="body2">{formatEUR(s.results.investmentCost)}</Typography>
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  )
}
